import { Stack, Typography } from '@mui/material'
import { LockOutlined } from '@mui/icons-material'

import { AccessContext } from '@/api/access-codes/types'
import { HttpError } from '@/api/http'

import AccessGateLayout from './AccessGateLayout'
import AccessCodeForm from './AccessCodeForm'

interface AccessGateLockedProps {
  context: AccessContext
  code: string
  isPending: boolean
  error: HttpError | null
  onCodeChange: (code: string) => void
  onSubmit: () => void
}

const AccessGateLocked: React.FC<AccessGateLockedProps> = ({
  context,
  code,
  isPending,
  error,
  onCodeChange,
  onSubmit,
}) => {
  return (
    <AccessGateLayout>
      <LockOutlined color="primary" sx={{ fontSize: 72 }} />

      <Stack spacing={0.5} width="100%">
        <Typography variant="h6" fontWeight={700}>
          Carregador de {context.entity_name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {context.message ||
            `Este carregador pertence a ${context.entity_name}. Você ainda não tem acesso a esta organização.`}
        </Typography>
      </Stack>

      {context.accepts_access_code ? (
        <AccessCodeForm
          code={code}
          isPending={isPending}
          error={error}
          onCodeChange={onCodeChange}
          onSubmit={onSubmit}
        />
      ) : (
        <Typography variant="body2" color="text.secondary">
          Procure o administrador ou síndico de <strong>{context.entity_name}</strong> para liberar seu acesso.
        </Typography>
      )}
    </AccessGateLayout>
  )
}

export default AccessGateLocked
